(function ($) {
    'use strict';

    acom_app.views.Nav = Backbone.View.extend({
        el: '.acom-nav-wrapper',
        template: _.template($('#acom-nav-template').html()),
        initialize: function () {},
        render: function () {
            this.close()

            var menus = window.acom_app.models.helper.get('menus')
            var menu_slug = window.acom_app.models.settings.get('content.menu_menu_slug')
            var result = {
                menu_items: {}
            }

            if (menu_slug && menus[menu_slug]) {
                var menu_items = menus[menu_slug].items
                if (menu_items.length > 0) {
                    _.each(menu_items, function (val, key) {
                        var childs = []

                        _.each(menu_items, function (item, key) {
                            if(+val.ID == +item.menu_item_parent){
                                childs.push({
                                    parent: item.menu_item_parent,
                                    title: item.title,
                                    url: item.url
                                })
                            }
                        })

                        if(val.menu_item_parent == '0'){
                            result['menu_items'][val.ID] = {
                                parent: val.menu_item_parent,
                                childs: childs,
                                title: val.title,
                                url: val.url
                            };
                        }
                    });
                }
            }

            var html = this.template(result)
            this.$el.append(html)

            return this
        },
        close: function () {
            $('.acom-nav-wrapper').html('')
            this.unbind()
        }
    })
})(jQuery)